import React, { useEffect, useState } from "react";
import styles from "./chatReply.module.scss";
import ChatLike from "../chatLike";
import { Tooltip } from "antd";
import ChatHoverOption from "../chatHoverOption";
import ChatReplyInner from "../chatReplyInner";
import moment from "moment";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, initialStateModel } from "../../../../models/model";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import ChatUserInfo from "../chatUserInfo";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import ChatImageMessage from "../imageChat";
import ChatFileInner from "../chatFileInner";
import { HighlightSearch } from "../../chatsection/highlightsearch";
import { strickerFormat,gifFormat, urlify } from "../../../../base/utils";
import ChatStickerMessage from "../chatSticker";
import ChatGifMessage from "../chatGif";
import ChatMentionMessage from "../atMention";
import ChatMapLocation from "../location";
import CloudReplyImage from "../chatFileInner/cloudFilesReplyImageDis";
import { ChatService } from "../../../../base/chatService";
type chatReplyMessageProps = {
  searchedData?: any;
  data: any;
  groupdata: any;
  savedData: any;
  timeValue?:any
};
export default function ChatReplyMessage({ data, groupdata, searchedData, savedData,timeValue }: chatReplyMessageProps) {
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  const chatWindowReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);

  let { fromcaller_details, timestamp, direction, message, id } = data;
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const mention_mem:Array<any> =chatWindowReducer?.chatWindowDetails?.teammembersdetails || [];
  const [longText, setlongtext] = useState(0);
  useEffect(() => {}, [searchedData]);

  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
  }, [savedData]);
  try {
    let htimestamp = data && moment(data.timestamp).format("hh:mm A");
    let replyinnerDetails = data?.message?.replyMsgBody;
    let imgArr: any = [];
    imgArr.push(data);
    const handleOnChange = (e: any) => {
      let deletedArray: any = chatReducer?.selectMessageData;
      let index = [];
      if (e.target.checked) {
        deletedArray?.push(data);
        store.dispatch({
          type: Types.SELECT_MESSAGE_ARRAY,
          payload: {
            selectMessageData: deletedArray
          }
        });
      } else {
        index = deletedArray?.indexOf(data);
        deletedArray?.splice(index, 1);
        store.dispatch({
          type: Types.SELECT_MESSAGE_ARRAY,
          payload: {
            selectMessageData: deletedArray
          }
        });
      }
    };

    const handleOnChange1 = (data: any, direction:string) => {
      if (chatReducer?.multiOption && (direction=== "IN" || direction=== "OUT")) {
        ChatService.selectedMessageDispatch(data);
      }
       else if (chatReducer?.isDelete && direction=== "OUT"){
        ChatService.selectedMessageDispatch(data);
       }
    };

    const handlehighlightHover = () => {
      var element: HTMLElement | any = document.getElementById(id) || null;
      if (element != null) {
        element.classList.add("highlighthover");
      }
    };



    let message_text = data?.message?.body;
    let mstext = message_text?.toString()
    message_text =
      message_text &&
      message_text
        ?.toString()
        ?.replace(
          /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim,
          '<a href="$1" target="__blank">$1</a>'
        );
    message_text = message_text?.replace(/\n/g, "<br />");
    let wwwPattern = /(^|[^\\/])(www\.[\S]+(\b|$))/gim;
    message_text = message_text?.replace(wwwPattern, '$1<a href="http://$2" target="_blank">$2</a>');
    message_text = message_text?.replace(/\n/g, "<br />");
    if (searchedData !== "" && searchedData !== undefined) {
      const regexs = new RegExp("(" + searchedData + ")", "gi");
      message_text = message_text?.replace(
        regexs,
        '<span style="background-color:#FBF4C5" tabindex="0" class="tranText">$1</span>'
      );
    }
    if (mstext?.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
    const readMoreChange = ()=>{
      setlongtext(1);
    }
    var fileArr: any = []; var fileRes: any = [];
    if (message?.messageType === "IMAGE" && (strickerFormat.indexOf(message?.body?.fileType) !== -1 || gifFormat.indexOf(message?.body?.fileType) !== -1)) {
      fileArr.push(data);
    }
    if (message?.messageType === "FILE" ) {
      fileRes.push(data);
    }
   
  let message_text_search = message_text;
  if (message?.messageType === "AT_MENTION"){
    if (mstext?.length > 760 && longText === 0) {
      message_text_search = mstext?.substring(0, 760) + "...";
    }
  mention_mem.map((value:any)=>{
    const callerID = value?.caller_id.toString();
    var re = new RegExp(`${"@"+(callerID)}`, 'g');
    message_text_search = message_text_search.replace(re,
      '<span class="'+styles.atMention+'">@'+callerID+'</span>').replace(/<\/?a[^>]*>/g," ");
   
  });
}     let isBookmark:any = data?.message?.isSave;
let widthMulti = (!data?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data?.message?.isEdit ?"saveEdited": 
(!data?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data?.message?.isEdit ? "onlyEdited" : "widthDefault";

    // let fileArr = Array.isArray(groupdata) && groupdata.length >0 && _.filter(groupdata, function(o:any) { return o.message?.messageType === "FILE"; });

    return (
      <>
        {direction === "IN" ? (
          <div className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } ${styles.chatMsg} lftMessage ${styles.leftMessage} ${(chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption? "checking" : ""}`} id={id}
            onClick={() => handleOnChange1(data, "IN")}>
        
           {timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
              <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className="userinfoIcon leftSide" />
              <div className={styles.convMemName}>
                <span>{fromcaller_details===undefined?'Unknown User':fromcaller_details?.caller_id}</span>
              </div>
            </div> }
            <div className={styles.chatLeftMessages}>
              <div className={styles.chatLeft}>
                <Tooltip title={htimestamp} className="cusTooltip" overlayClassName="customTooltip">
                  <div className={styles.chatTime}>{htimestamp}</div>
                </Tooltip>
                <div className={message?.messageType === "TEXT"?`msgContentLft ${styles.chatContent} ${styles.textrst}` :`msgContentLft ${styles.chatContent}`  }>
                  <div className={styles.replyChat}>
                    <div className={styles.replyHeader}>
                      {/* <img src={replyIcon} alt="" /> */}
                      <span className={styles.iconReply}></span>
                      <span className="">Replied</span>
                    </div>
                    <div className={styles.replyTopSec}>
                      <ChatReplyInner isBottom={false} replyingMessage={replyinnerDetails} />
                    </div>
                    {message?.messageType === "TEXT" ? (
                      <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                      {mstext?.length > 760 && longText === 0 && 
                        <span className={id === savedData ? "focusText" : "textmsg"} tabIndex={0}> 
                        <HighlightSearch content={mstext} searchedData={searchedData}></HighlightSearch>
                        {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                      </span> }

                  {(( mstext?.length < 760) || (longText === 1)) && 
                  <span  className={id===savedData?"focusText":"textmsg" } tabIndex={0} dangerouslySetInnerHTML={{__html:message_text?.replace(/\n/g, "<br />")}}>
                  </span> }
                   
                        <span className={widthMulti}></span>  </span>
                      </div>
                    ) : message?.messageType === "FILE" ? (
                      <ChatFileInner replyingMessage={data?.message?.body} data={data} />
                    ) : // pls don't remove
                    //<ChatFilesMessage data={fileArr} groupdata={fileArr}/> :
                    null}
                      {message?.messageType === "IMAGE" && strickerFormat.indexOf(message?.body?.fileType) === -1 && gifFormat.indexOf(message?.body?.fileType) !== -1 && !message?.body?.isCloudfiles &&
                    <ChatGifMessage multiData={fileArr}
                    data={fileArr}  savedData={savedData} timeValue={0}/>}
                      {message?.messageType === "IMAGE" && gifFormat.indexOf(message?.body?.fileType) === -1 &&strickerFormat.indexOf(message?.body?.fileType) === -1 && !message?.body?.isCloudfiles &&<ChatImageMessage data={data} />}
                    
                     {message?.messageType === "IMAGE" && strickerFormat.indexOf(message?.body?.fileType) !== -1 && !message?.body?.isCloudfiles &&
                     <ChatStickerMessage
                     data={fileArr}
                     multiData={fileArr}
                     audioVideo={false}
                     savedData={savedData}
                     timeValue={0}
                   ></ChatStickerMessage>}

                   {message?.messageType === "IMAGE"  && message?.body?.isCloudfiles &&
                   <CloudReplyImage replyingMessage={data?.message?.body} data={data} groupdata={fileRes}/>
                   }
                  {message?.messageType === "GEO" && 
                  <ChatMapLocation data={data} searchedData={searchedData}  savedData={savedData} previousItem="" />
  }  
                {message?.messageType === "AT_MENTION" && 
                    <div className="textContent">
                          <span className={`textmsg ${styles.messageContent}`} >
                      {mstext?.length > 760 && longText === 0 && 
                        <span className={id === savedData ? "focusText" : "textmsg"} tabIndex={0}> 
                      <span dangerouslySetInnerHTML={{__html: urlify(message_text_search?.replace(/\n/g, "<br />"))}}></span>
                        {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                      </span> }

                  {(( mstext?.length < 760) || (longText === 1)) && 
                 <span dangerouslySetInnerHTML={{__html: urlify(message_text_search)}}></span> }
                   
                        <span className={widthMulti}></span>  </span>
                    </div>
                  }
                    {message?.messageType !== "IMAGE" &&  <ChatLeftInfo userDetails={fromcaller_details} timeStamp={timestamp} message={data}></ChatLeftInfo>}
                    {message?.messageType === "IMAGE" && strickerFormat.indexOf(message?.body?.fileType) !== -1 &&<ChatLeftInfo userDetails={fromcaller_details} timeStamp={timestamp} message={data}></ChatLeftInfo>
                  }  
                  </div>

              
                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption
                      className="hoverList hoverListleft"
                      data={data}
                      multiFile={imgArr}
                      highlightHover={handlehighlightHover}
                    />
                  </div>
                </div>
              </div>
              <ChatLike
                    className="likeLeft"
                    placement="topRight"
                    tooltipTitle={replyinnerDetails?.likeduserdetails}
                    message={data}
                  />
            </div>
            {(!chatReducer?.isDelete && chatReducer?.multiOption) && (
              <URCheckBoxCall
                checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false}
                className="chatSelectRight"
                // onChange={handleOnChange}
              />
            )}
          </div>
        ) : (
          <div
          className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } rtMessage ${styles.chatMsg} ${styles.rightMessage} 
        ${(chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption? "checking" : ""}`
          } 
            id={id} onClick={() => handleOnChange1(data, "OUT")}
          >
            
            {timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
              <div className={styles.convMemName}>
                <span>You</span>
              </div>
              <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className="userinfoIcon rightSide" />
            </div>}
            <div className={styles.chatRightMessages}>
              <div className={styles.chatRight}>
                <div className={message?.messageType === "TEXT"?`msgContentRT ${styles.chatContent} ${styles.textrst}` :`msgContentRT ${styles.chatContent}`  }>
                  {/* <div className={groupdata?.length > 1? `${styles.replyChat} ${styles.innerpadadjust}` :`${styles.replyChat} ${styles.oneMessageReply}`}>
                   */}
                  <div className={styles.replyChat}>
                    <div className={styles.replyHeader}>
                      {/* <img src={replyIcon} alt="" /> */}
                      <span className={styles.iconReply}></span>
                      <span className="">Replied</span>
                    </div>
                    <div className={styles.replyTopSec}>
                      <ChatReplyInner isBottom={false} replyingMessage={replyinnerDetails} />
                    </div>
                    {message?.messageType === "IMAGE" && strickerFormat.indexOf(message?.body?.fileType) === -1 && gifFormat.indexOf(message?.body?.fileType) !== -1 && !message?.body?.isCloudfiles &&
                    <ChatGifMessage multiData={fileArr}
                    data={fileArr}  savedData={savedData} timeValue={0}/>}
                      {message?.messageType === "IMAGE" && gifFormat.indexOf(message?.body?.fileType) === -1 &&strickerFormat.indexOf(message?.body?.fileType) === -1  && !message?.body?.isCloudfiles && <ChatImageMessage data={data} />}
                    
                     {message?.messageType === "IMAGE" && strickerFormat.indexOf(message?.body?.fileType) !== -1 && !message?.body?.isCloudfiles &&
                     <ChatStickerMessage
                     data={fileArr}
                     multiData={fileArr}
                     audioVideo={false}
                     savedData={savedData}
                     timeValue={0}
                   ></ChatStickerMessage>}

                    {message?.messageType === "IMAGE" && message?.body?.isCloudfiles && 
                      <CloudReplyImage replyingMessage={data?.message?.body} data={data} groupdata={fileRes}/> }

                    {message?.messageType === "AT_MENTION" && 
                    <div className="textContent">
                          <span className={`textmsg ${styles.messageContent}`} >
                      {mstext?.length > 760 && longText === 0 && 
                        <span className={id === savedData ? "focusText" : "textmsg"} tabIndex={0}> 
                      <span dangerouslySetInnerHTML={{__html:urlify(message_text_search?.replace(/\n/g, "<br />"))}}></span>
                        {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                      </span> }

                  {(( mstext?.length < 760) || (longText === 1)) && 
                 <span dangerouslySetInnerHTML={{__html:urlify(message_text_search?.replace(/\n/g, "<br />"))}}></span> }
                   
                        <span className={widthMulti}></span>  </span>
                    </div>
                  }
                    {message?.messageType === "TEXT" ? (
                      <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                      {mstext?.length > 760 && longText === 0 && 
                        <span className={id === savedData ? "focusText" : "textmsg"} tabIndex={0}> 
                        <HighlightSearch content={mstext} searchedData={searchedData}></HighlightSearch>
                        {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                      </span> }

                  {(( mstext?.length < 760) || (longText === 1)) && 
                  <span  className={id===savedData?"focusText":"textmsg" } tabIndex={0} dangerouslySetInnerHTML={{__html:message_text?.replace(/\n/g, "<br />")}}>
                  </span> }
                   
                        <span className={widthMulti}></span>  </span>
                      </div>
                    ) : message?.messageType === "FILE" ? (
                      <ChatFileInner replyingMessage={data?.message?.body} data={data} groupdata={fileRes}/>
                    ) : // pls don't remove
                    //<ChatFilesMessage data={fileArr} groupdata={fileArr}/> :
                    null}
                 {message?.messageType !== "IMAGE" &&  <ChatRightInfo
                      userDetails={fromcaller_details}
                      timeStamp={timestamp}
                      message={data}
                    ></ChatRightInfo>}
                   {message?.messageType === "IMAGE" && strickerFormat.indexOf(message?.body?.fileType) !== -1 &&<ChatRightInfo
                      userDetails={fromcaller_details}
                      timeStamp={timestamp}
                      message={data}
                    ></ChatRightInfo>
                  }  
                  </div>

                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption
                      className="hoverList hoverListright"
                      data={data}
                      multiFile={imgArr}
                      highlightHover={handlehighlightHover}
                    />
                  </div>
                </div>
                <Tooltip
                  placement="topRight"
                  title="Today at 12:13 PM"
                  className="cusTooltip"
                  overlayClassName="customTooltip"
                >
                  <div className={styles.chatTime}>{htimestamp}</div>
                </Tooltip>
              </div>
              <ChatLike
                className="likeRight"
                placement="topRight"
                tooltipTitle={replyinnerDetails?.likeduserdetails}
                message={data}
              />
            </div>
            {(chatReducer?.isDelete || chatReducer?.multiOption) && (
              <URCheckBoxCall
                checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false}
                className="chatSelectRight"
                // onChange={handleOnChange}
              />
            )}
          </div>
        )}

        {/* MULTIPLE THREAD CONCEPT PLS DON'T REMOVE THE CODE*/}

        {/* {direction === "IN" ? (
        <div className={`${styles.chatMsg} ${styles.leftMessage}`} id={id}>
          <div className={`${styles.chatUserDetails}`}>
            <ChatUserInfo userDetails = {fromcaller_details} className='userinfoIcon leftSide'/>
            <ChatLeftInfo userDetails = {fromcaller_details}
              timeStamp = {timestamp} message={data}></ChatLeftInfo>
          </div>
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              <Tooltip title={htimestamp} className='cusTooltip'
                overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>
              <div className={styles.chatContent}>
              <div className={groupdata?.length > 1? `${styles.replyChat} ${styles.innerpadadjust}` :`${styles.replyChat} ${styles.oneMessageReply}`}>
              
                  <div className={styles.replyHeader}>
                    <img src={replyIcon} alt="" />
                    <span className="">Replied</span>
                  </div>
                  <div className={styles.replyTopSec}>
                   <ChatReplyInner isBottom={false} replyingMessage={replyinnerDetails}/>
                  </div>
                  { groupdata?.length > 1 &&  <div className={`${styles.replyThread} ${styles.marbtmmin}`} onClick={()=>onChangeReply(mount)} >
                      <span>{groupdata.length} replies from {unique.toString()}</span></div>}
                    {mount && Array.isArray(groupdata) && groupdata.length>1 && groupdata.map((msgList: any, index: any) => {
                      var filesArr:any =[];
                      if(msgList?.message?.messageType === "FILE" ){
                        filesArr.push(msgList);
                      }
                      return (
                        <>
                           <div className={styles.chatMsgreplyInnertop}>
                          <div className={`${styles.chatReplyusersec} ${styles.chatUserDetails} `}>
                            <ChatUserInfo userDetails = {msgList.fromcaller_details} className='userinfoIcon leftSide'/>
                            <ChatLeftInfo userDetails = {msgList.fromcaller_details}
                              timeStamp = {timestamp} message={msgList}></ChatLeftInfo>
                          </div>
                            {msgList?.message?.isLink && <a className={styles.linkAlign}> <p dangerouslySetInnerHTML={{__html:msgList.message.body.replace(/\n/g, "<br />")}}></p></a> }
                                 {!msgList?.message?.isLink && msgList?.message?.messageType === "TEXT" ?
                    <p className={styles.paratxtcont} dangerouslySetInnerHTML={{__html:msgList.message.body.replace(/\n/g, "<br />")}}></p>
                    : msgList?.message?.messageType === "FILE" ?
                      <ChatFilesMessage data={filesArr} groupdata={filesArr}/> :
                    null }
                    {msgList?.message?.messageType === "IMAGE" && <ChatImageMessage data={msgList}/> }
                    {msgList?.message?.isEdit ? ( <span className={`${styles.editing} ${styles.editAlign}` } >(edited)</span> ):null}
           
                
                          <ChatLike className='likeLeft replylftside' placement="topRight"
                          tooltipTitle={replyinnerDetails?.likeduserdetails} message={msgList}/>
                          <div className={`chatInnerHoveroptn ${styles.replyrightbtm} ${styles.hoverOptions}`}>
                            <ChatHoverOption className='hoverList hoverListright replyRight'  data={msgList} replyHover={true} highlightHover={handlehighlightHover}/>
                            </div>
                        </div>  
                        </>)
                    })}
        {Array.isArray(groupdata) && groupdata?.length === 1 &&<>
              {message?.messageType === "TEXT" ?
                    <p dangerouslySetInnerHTML={{__html:message_text.replace(/\n/g, "<br />")}}></p>
                    : message?.messageType === "FILE" ?
                      <ChatFilesMessage data={fileArr} groupdata={fileArr}/> :
                    null }
                    {message?.messageType === "IMAGE" && <ChatImageMessage data={data}/> }
                  {data?.message?.isEdit ? ( <span className={styles.editing} >(edited)</span> ):null}
           
                </>}
                </div>
                {Array.isArray(groupdata) && groupdata?.length === 1 && <ChatLike className='likeLeft' placement="topRight"
                  tooltipTitle={replyinnerDetails?.likeduserdetails} message={data}/>}
              </div>
            </div>
          </div>
          <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListleft' data={data} multiFile={imgArr} highlightHover={handlehighlightHover}/></div>
        </div>
      ): (
        <div className={`${styles.chatMsg} ${styles.rightMessage}
        ${(chatReducer?.isDelete || chatReducer?.isForward)? "checkboxing" : ""}
         `} onClick={handleCheckBoxClick} id={id}>
          <div className={`${styles.chatUserDetails}`}>
            <ChatRightInfo userDetails = {fromcaller_details}
              timeStamp = {timestamp} message={data}></ChatRightInfo>
            <ChatUserInfo userDetails = {fromcaller_details}  className='userinfoIcon rightSide'/>
          </div>
          <div className={styles.chatRightMessages} >
            <div className={styles.chatRight} >
              <div className={styles.chatContent}>
                <div className={groupdata?.length > 1? `${styles.replyChat} ${styles.innerpadadjust}` :`${styles.replyChat} ${styles.oneMessageReply}`}>
                  <div className={styles.replyHeader}>
                    <img src={replyIcon} alt="" />
                    <span className="">Replied</span>
                  </div>
                  <div className={styles.replyTopSec}>
                  <ChatReplyInner isBottom={false} replyingMessage={replyinnerDetails}/>
                    </div>
                    { groupdata?.length > 1 &&  <div className={`${styles.replyThread} ${styles.marbtmmin}`} onClick={()=>onChangeReply(mount)} >
                      <span>{groupdata.length} replies from {unique.toString()}</span></div> }
                    { groupdata?.length > 1 && mount && Array.isArray(groupdata) && groupdata.map((msgList: any, index: any) => {
                        var filesArr:any =[];
                        if(msgList?.message?.messageType === "FILE" ){
                          filesArr.push(msgList);
                        }
                       return (
                        <>
                        <div className={styles.chatMsgreplyInnertop}>
                          <div className={`${styles.chatReplyusersec} ${styles.chatUserDetails} `}>
                            <ChatUserInfo userDetails = {msgList.fromcaller_details} className='userinfoIcon leftSide'/>
                            <ChatLeftInfo userDetails = {msgList.fromcaller_details}
                              timeStamp = {timestamp} message={msgList}></ChatLeftInfo>
                             </div>
                             {msgList?.message?.isLink && <a className={styles.linkAlign}> <p dangerouslySetInnerHTML={{__html:msgList.message.body.replace(/\n/g, "<br />")}}></p></a> }
                                 
                                 {!msgList?.message?.isLink && msgList?.message?.messageType === "TEXT" ?
                    <p className={styles.paratxtcont} dangerouslySetInnerHTML={{__html:msgList.message.body.replace(/\n/g, "<br />")}}></p>
                    : msgList?.message?.messageType === "FILE" ?
                      <ChatFilesMessage data={filesArr} groupdata={filesArr}/> :
                    null }
       {msgList?.message?.messageType === "IMAGE" && <ChatImageMessage data={msgList}/> }
                    {msgList?.message?.isEdit ? ( <span className={`${styles.editing} ${styles.editAlign}`} >(edited)</span> ):null}
           
                          <ChatLike className='likeRight replylftside' placement="topRight"
                          tooltipTitle={replyinnerDetails?.likeduserdetails} message={msgList}/>
                          <div className={`chatInnerHoveroptn ${styles.replyrightbtm} ${styles.hoverOptions}`}>
                            <ChatHoverOption className='hoverList hoverListright replyRight'  data={msgList} replyHover={true} highlightHover={handlehighlightHover}/>
                            </div>
                        </div>
                        
                        </>)
                    })} 
              {Array.isArray(groupdata) && groupdata?.length === 1 &&<>
              {message?.messageType === "TEXT" ?
                    <p dangerouslySetInnerHTML={{__html:message_text.replace(/\n/g, "<br />")}}></p>
                    : message?.messageType === "FILE" ?
                      <ChatFilesMessage data={fileArr} groupdata={fileArr}/> :
                    null }
                    {message?.messageType === "IMAGE" && <ChatImageMessage data={data}/> }
                  {data?.message?.isEdit ? ( <span className={styles.editing} >(edited)</span> ):null}
           
                </>}

                      
                </div>
                {Array.isArray(groupdata) && groupdata?.length === 1 &&<ChatLike className='likeRight' placement="topRight"
                  tooltipTitle={replyinnerDetails?.likeduserdetails} message={data}/> }
              </div>
              <Tooltip placement="topRight" title='Today at 12:13 PM'
                className='cusTooltip' overlayClassName='customTooltip'>
                <div className={styles.chatTime}>{htimestamp}</div></Tooltip>
            </div>
          </div>
          <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
            <ChatHoverOption className='hoverList hoverListright'  data={data} multiFile={imgArr} highlightHover={handlehighlightHover}/></div>
          {(chatReducer?.isDelete || chatReducer?.isForward) &&<URCheckBoxCall
            checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false}
            className="chatSelectRight" onChange={handleOnChange}/>}
        </div>
      )}
      */}
      </>
    );
  } catch (e) {
    console.log(e,"00000000000000")
    return <p style={{ color: "red" }}>Something went wrong</p>;
  }
}
